import React, { useEffect, useRef, useState } from 'react';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import '../css/ImageWithZoom.css';
import { ImageListItemBar, Modal, Tooltip } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { ImageModal } from './ImageListModal';

interface ImagesWithZoomProps {
  src: string;
  srcArray?: ImageModal[];
  alt: string;
  activateZoom?: boolean;
  activateRotation?: boolean;
  onClickImage?: (value: any) => void;
  activateNavigation?: boolean
  index?: number
}

const ImagesWithZoom: React.FC<ImagesWithZoomProps> = ({
  src, alt,
  srcArray,
  // activateZoom=true, 
  activateRotation = true,
  activateNavigation = false,
  index = 0,
}) => {
  const [currentImage, setCurrentImage] = useState(src);
  const [currentIndex, setCurrentIndex] = useState(index);
  const [isOpen, setIsOpen] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [enableMagnify, setEnableMagnify] = useState(false);
  // const [mousePosition, setMousePosition] = useState<{ top: number; left: number } | null>(null);
  const focusedImage = useRef<HTMLImageElement | null>(null);
  const focusedButtons = useRef<HTMLButtonElement | null>(null);

  const openModal = () => {
    setIsOpen(true);
    setCurrentImage(src)
    setCurrentIndex(index)
  };
  const closeModal = () => {
    setEnableMagnify(false)
    setIsOpen(false)
  };

  const handleRotate = () => {
    setRotation(prevRotation => prevRotation + 90); // Gira la imagen 90 grados
  };
  // const handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
  //     const rect = event.currentTarget.getBoundingClientRect();
  //     const x = event.clientX - rect.left; // X position within the element
  //     const y = event.clientY - rect.top;  // Y position within the element

  //     setMousePosition({
  //         top: y,
  //         left: x,
  //     });
  // };
  const handleNextImage = () => {
    if(srcArray && srcArray.length > 1){
      if(currentIndex + 1 < srcArray.length){
        setCurrentImage(srcArray![currentIndex + 1].img);
        setCurrentIndex(currentIndex + 1);
      }else{
        setCurrentImage(srcArray![0].img);
        setCurrentIndex(0);
      }
    }
  };

  const handlePrevImage = () => {
    if(srcArray && srcArray.length > 1){
      if(currentIndex - 1 >= 0){
        setCurrentImage(srcArray![currentIndex - 1].img);
        setCurrentIndex(currentIndex - 1);
      }else{
        setCurrentImage(srcArray![srcArray.length - 1].img);
        setCurrentIndex(srcArray.length - 1);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (focusedImage.current && !focusedImage.current.contains(event.target as Node)
        && !focusedButtons.current!.contains(event.target as Node)) {
        closeModal();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const zoom = 3



  const imgRef = useRef<HTMLImageElement | null>(null);
  const glassRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const img = imgRef.current;
    const glass = glassRef.current;

    if (!img || !glass) return;

    // Set background properties for the magnifier glass
    glass.style.backgroundImage = `url('${currentImage}')`;
    glass.style.backgroundRepeat = 'no-repeat';
    glass.style.backgroundSize = `${img.width * zoom}px ${img.height * zoom}px`;

    const bw = 3;
    const w = glass.offsetWidth / 2;
    const h = glass.offsetHeight / 2;

    const moveMagnifier = (e: MouseEvent | TouchEvent) => {
      e.preventDefault();
      const pos = getCursorPos(e);
      let x = pos.x;
      let y = pos.y;

      // Prevent the magnifier glass from being positioned outside the image
      if (x > img.width - (w / zoom)) x = img.width - (w / zoom);
      if (x < w / zoom) x = w / zoom;
      if (y > img.height - (h / zoom)) y = img.height - (h / zoom);
      if (y < h / zoom) y = h / zoom;

      glass.style.left = `${x - w}px`;
      glass.style.top = `${y - h}px`;
      glass.style.backgroundPosition = `-${(x * zoom) - w + bw}px -${(y * zoom) - h + bw}px`;
    };

    const getCursorPos = (e: MouseEvent | TouchEvent) => {
      const a = img.getBoundingClientRect();
      const x = e instanceof MouseEvent ? e.pageX - a.left - window.pageXOffset : (e.touches[0].pageX - a.left - window.pageXOffset);
      const y = e instanceof MouseEvent ? e.pageY - a.top - window.pageYOffset : (e.touches[0].pageY - a.top - window.pageYOffset);
      return { x, y };
    };

    // Attach event listeners
    glass.addEventListener('mousemove', moveMagnifier);
    img.addEventListener('mousemove', moveMagnifier);
    glass.addEventListener('touchmove', moveMagnifier);
    img.addEventListener('touchmove', moveMagnifier);

    // return () => {
    // // Cleanup event listeners on unmount
    // glass.removeEventListener('mousemove', moveMagnifier);
    // img.removeEventListener('mousemove', moveMagnifier);
    // glass.removeEventListener('touchmove', moveMagnifier);
    // img.removeEventListener('touchmove', moveMagnifier);
    // };
  }, [enableMagnify]);


  useEffect(() => {
    if (!activateNavigation || !isOpen) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft') {
        handlePrevImage();
      } else if (e.key === 'ArrowRight') {
        handleNextImage();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [activateNavigation, isOpen, currentIndex, srcArray]);


  return (
    <div>
      <img
        src={src}
        alt={alt}
        width="300"
        height="200"
        style={{
          cursor: 'pointer', borderRadius: '5px', transition: '0.3s', maxWidth: '100%',
          objectFit: 'contain', boxShadow: '0 0 5px rgba(0, 0, 0, 0.5)',
        }}
        onClick={openModal}
      />

      {isOpen && (
        <Modal
          open={isOpen}
          onClose={closeModal}
          closeAfterTransition
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <div id="focus-img" className="" style={{ justifyContent: 'center', alignItems: 'center', margin: 'auto', maxWidth: '70%' }}>
            <span className="close" onClick={closeModal}>&times;</span>
            {/* focusedButtons */}
            {
              activateRotation ?
                <Tooltip title="Rotar imagen" ref={focusedButtons} >
                  <span className="rotate-img" onClick={handleRotate}>&#x21bb;</span>
                </Tooltip>
                : null
            }
            {
              <Tooltip title="Zoom" ref={focusedButtons} >
                <span className="zoom-img" onClick={() => setEnableMagnify(!enableMagnify)}>
                  <ZoomInIcon fontSize='large' />
                </span>
              </Tooltip>
            }
            {
              activateNavigation ?
              <>
                <Tooltip title="Imagen anterior" ref={focusedButtons} >
                  <span className="next-img-visualizer-img" onClick={handlePrevImage}>
                    <ArrowBack />
                  </span>
                </Tooltip>
                <Tooltip title="Imagen siguiente" ref={focusedButtons} >
                  <span className="prev-img-visualizer-img" onClick={handleNextImage}>
                    <ArrowForward />
                  </span>
                </Tooltip>
              </>
              : null
            }
            <div
              className='img-magnifier-container'
              style={{ justifyContent: 'center', alignItems: 'center', margin: 'auto'}}
            >

              <img ref={imgRef} className="modal-content"
                style={{ transform: `rotate(${rotation}deg)`, maxHeight: "80vh", margin: 'auto'}}
                src={currentImage} alt={alt} />
              {
                enableMagnify ?
                  <div ref={glassRef} className="img-magnifier-glass"
                    style={{ transform: `rotate(${rotation}deg)` }} />
                  : null
              }
            </div>
              {
                srcArray?.[currentIndex].title ? (
                  <ImageListItemBar
                    title={srcArray?.[currentIndex].title}
                    position={'bottom'}
                    sx={{
                      textAlign:"center",
                      backgroundColor: "black",
                      borderTop: "2px solid white"
                    }}
                  />
                )
                :
                alt ? (
                  <div className="caption">{alt}</div>
                )
                : null
              }
          </div>

        </Modal>

      )}
    </div>
  );
};

export default ImagesWithZoom;

/* {activateZoom && mousePosition && (
    <div
        className="magnifying-glass"
        style={{
            top: mousePosition.top,
            left: mousePosition.left,
            backgroundImage: `url(${src})`,
            backgroundPosition: `-${mousePosition.left * 1.5}px -${mousePosition.top * 1.5}px`,
            transform: `rotate(${rotation}deg)`
        }}
    />
)} 
    
<img ref={focusedImage} onMouseMove={handleMouseMove} className="modal-content" 
  style={{ transform: `rotate(${rotation}deg)` }}
  src={src} alt={alt} /> 
*/